import React from 'react';
import { ASSIGN_OWNER_TITLE } from './placeholders';

// The header's two buttons. Compose scrolls to and focuses the composer. Assign owner
// is a DISABLED placeholder: there is no write behind it and no member list to pick
// from, so it says why in its title instead of doing nothing when clicked.

const BUTTON = 'h-10 rounded-lg px-5 text-base font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-950';

/**
 * @param {object} props
 * @param {() => void} props.onCompose
 */
export default function ClientActions({ onCompose }) {
  return (
    <>
      <button type="button" onClick={onCompose} className={`${BUTTON} bg-brand text-gray-950 hover:opacity-90`}>
        Compose
      </button>
      <button
        type="button"
        disabled
        title={ASSIGN_OWNER_TITLE}
        className={`${BUTTON} border border-gray-300 bg-white text-gray-900 disabled:cursor-not-allowed disabled:opacity-60 dark:border-gray-700 dark:bg-gray-800/70 dark:text-gray-100`}
      >
        Assign owner
      </button>
    </>
  );
}
